/**
 * Pairs dashboard section.
 */

import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { PairsDataTable } from '@/components/pairs/remote/PairsDataTable';
import { useDetailsView } from '@/hooks/useDetailsView';
import { usePageActions } from '@/hooks/usePageActions';
import type { ElementWidth } from '@/types/interface-elements.types';

/** Props for {@link PairsSection}. */
interface PairsSectionProps {
  layoutWidth?: ElementWidth;
}

/** Dashboard widget: remote pairs list. */
export const PairsSection: React.FC<PairsSectionProps> = ({ layoutWidth = 'full' }) => {
  const navigate = useNavigate();
  const { canCreate, canEditRow, canExportExcel, canDissociate } = usePageActions('pairs');
  const { openRowId, openRow, closeRow } = useDetailsView();

  return (
    <div className="space-y-4">
      <PairsDataTable
        expandedRowId={openRowId}
        onToggleRow={openRow}
        onCloseDetails={closeRow}
        isSection={true}
        pageActions={{
          canEditRow,
          canExportExcel,
          canDissociate,
        }}
        showCreateButton={canCreate}
        onCreatePair={() => navigate('/pairs', { state: { initialTab: 'matching' } })}
      />
    </div>
  );
};
